module.exports = __webpack_public_path__ + "fonts/rGvHdJnr2l75qb0YND9NyIX0hVgzZQUfRDuZrPvH3D8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/rGvHdJnr2l75qb0YND9NyIX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = 334
// module chunks = 0